import { ErrorType } from 'shared/enums/ErrorType';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.errors.NetworkError';

export class NetworkError extends Error {
  response: Error & { isPotentialBot?: boolean };
  statusCode?: number;

  constructor(response, statusCode?) {
    super(response);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NetworkError);
    }

    const message =
      response?.data?.localized_messages?.[0] ||
      response?.data?.messages?.[0] ||
      response?.statusMessage ||
      t(`${TP}.message`, 'Oops, something went wrong.');

    const _statusCode = statusCode || response?.statusCode || response?.status || 500;

    this.name = ErrorType.NetworkError;
    this.message = message;
    this.statusCode = _statusCode;
    this.response = {
      ...response,
      name: ErrorType.NetworkError,
      message,
      // Explicitly preserve the isPotentialBot flag
      isPotentialBot: !!response?.isPotentialBot,
    };
  }
}
